import React from "react";
import { useSelector } from "react-redux";
import { asPercentage } from "../../../../utils/formatters";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";

const PrevClosingPercentMonthToDate = () => {
  const { prevClosingPercentMTD, prevClosingPercentMTDLink } = useSelector(
    (state) => state.firstRiders.firstTimeRiders?.closing
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <MoneyDisplay
      value={asPercentage(prevClosingPercentMTD)}
      currency="%"
      currencyLocation="end"
      url={prevClosingPercentMTDLink}
      disableAnimation={isUserQa}
    />
  );
};

export default PrevClosingPercentMonthToDate;
